const API_URLS = {
  apiVersion: "/api/v1/",
  oAuthToken: "/services/oauth2/token",
  oAuthRevoke: "/services/oauth2/revoke",
  azurePubSubProtocal: "json.webpubsub.azure.v1",
  getPubSubTokenURL: "/subscription/token",
  userManualURL: "https://desalitechreportsprod.blob.core.windows.net/documentation/manual.pdf",
  /** Admin URLs - Starts */
  adminSystemsURL: "/admin/systems",
  adminUsersURL: "admin/users",
  adminLayoutURL: "admin/layouts",
  /** Admin URLs - Ends */
  systemsURL: "/systems",
  loginTimeURL: "/lastlogin",
  landingPageURL: "/landing",
  dashboardsURL: "/dashboards",
  chartsURL: "/charts",
  analyticsURL: "/analytics",
  reportsURL: "/reports",
  tagsURL: "/tags",
  reportsHistoryURL: "/reports/history",
  alarmHistoryURL: "/alarms/history",
  activeAlarmsURL: "/alarms/active",
  activeAnomalyURL: "/insights",
  anomalyURL: "systems/insights",
  anomalyListURL: "/insights/list",
  userRoleURL: "user/role",
  roleURL: "roles",
  systemsNameURL: "/systems/name",
  notificationsReceiversURL: "/settings/notifications/receivers",
  timeSeriesURL: "timeseriesData",
  dupontWaterSolution: "https://www.dupont.com/water",
  alarms: "/alarms",
  allAlarms: "/all/alarms",
  baselineURL: "/baselines",
  baselineByTimeURL: "/baselines/values",
  default: "/default",
  tagMapping: "/mapping",
  normalizationData: "/normalizationData",
  widgets: "/widgets",
  reorder: "reorder",
  normalizationRanges: "/normalization/ranges",
  termsOfUse: "https://www.dupont.com/legal-notices-and-terms-of-use.html",
  privacyUrl: "https://www.dupont.com/privacy.html",
  dupontUrl: "https://www.dupont.com/",
  enableWidget: "/widgets/enabled",
  userDetailsURL: "/user/details",
  cipURL: "/cip",
  accumulativeDataURL: "/accumulative",
  membranePrediction: "/prediction/membrane"
};

export default API_URLS;
